import React from 'react';
import styles from './Alert.module.css'
import { getAlertColorsAndIcon, getAlertTimestamp } from '../../utils/alertUtils';
import { formatDateWithTime } from '../../utils/dateUtils';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const AlertBadge = React.forwardRef(({ alert }, ref) => {
    
    let {icon, background, border} = getAlertColorsAndIcon(alert);
    const alertTimestamp = getAlertTimestamp(alert)
    const dateFormat = useSelector((state)=>state.userInfo.dateFormat)

    const renderTooltip = (description) => (props) => (
        <Tooltip id={`tooltip-${description}`} {...props}>
            {alert.alert_hover_display ?? ''}
            <br />
            {formatDateWithTime(alertTimestamp, dateFormat)}
        </Tooltip>
    );

    return (
        <OverlayTrigger  
                placement="top"
                delay={{ show: 50, hide: 50 }}
                overlay={renderTooltip()}
            >
        <button
            ref={ref}
            disabled
            className={styles.badgeContainer}
            style={{ border: `0.5px solid ${border}`, backgroundColor: background }}
        >
            
            {icon}
            <span style={{paddingLeft:"5px"}}>{alert.alert_display_name ?? alert.alert_name}</span>
        </button>
         </OverlayTrigger>
    );
});

export default AlertBadge;
